import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qh273szwef: FaireBrandEntity = {
  token: "b_qh273szwef",
  type: "brand",
  name: "Microjoy",
  avatarUrl:
    "https://cdn.faire.com/fastly/a861c54e605ff5ad514e3d53d97dd08bcf8eaf0f627954b4b2be077c4d48410c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/777e8e2560479f3cfae9ec146506d23df1606548c6f59c13c128d7eb3b89a763.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a861c54e605ff5ad514e3d53d97dd08bcf8eaf0f627954b4b2be077c4d48410c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/777e8e2560479f3cfae9ec146506d23df1606548c6f59c13c128d7eb3b89a763.jpeg",
  location: "PORTLAND, OR, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 60,
  isTopShop: true,
  isInsider: true,
  description:
    "Functional mushroom based goods so you can feel the way you want to feel. Microjoy is a celebration of small gratitudes, helping cultivate the practice of everyday joy. Our approach to wellness is based on a philosophy of plant based, great tasting remedies that work quickly and effectively. Each of our handcrafted functional formulas are created to address a specific challenge with mental health and wellness at the core. Sourced from the best suppliers and tested for quality, Microjoy exists to help unveil a more calm, well-rested, resilient version of yourself.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:22.369Z",
    importedBy: "entity-db-cli",
  },
};
